export const ON_DISPLAY_MODAL_USERS = 'ON_DISPLAY_MODAL_USERS';
export const ON_DISPLAY_DETAIL_CONTACT = 'ON_DISPLAY_DETAIL_CONTACT';
export const ADD_USER_TO_CONVERSATION_LIST = 'ADD_USER_TO_CONVERSATION_LIST';
export const ON_CHANGE_CONVERSATION = 'ON_CHANGE_CONVERSATION';

export const ON_LOAD_MESSAGE_LIST = 'ON_LOAD_MESSAGE_LIST';
export const ON_LOAD_MESSAGE_LIST_SUCCESS = 'ON_LOAD_MESSAGE_LIST_SUCCESS';
export const ON_LOAD_MESSAGE_LIST_FAILED = 'ON_LOAD_MESSAGE_LIST_FAILED';

export const ON_LOAD_USER_CONVERSATION_LIST = 'ON_LOAD_USER_CONVERSATION_LIST';
export const ON_LOAD_USER_CONVERSATION_LIST_SUCCESS = 'ON_LOAD_USER_CONVERSATION_LIST_SUCCESS';
export const ON_LOAD_USER_CONVERSATION_LIST_FAILED = 'ON_LOAD_USER_CONVERSATION_LIST_FAILED';

export const ON_RESET_USER_CONVERSATION = 'ON_RESET_USER_CONVERSATION';
